export const API_KEY_INTEGRATION_ALLOWLIST_ROWS = [
    { key: "abacus", label: "Abacus" },
    { key: "wpos", label: "WPOS" },
    { key: "kounta", label: "Kounta" }
];
export const API_KEY_ALLOWLIST_FORMIK_PREFIX = "allowlist_integration";
export function defaultApiKeyIntegrationAllowlist() {
    return API_KEY_INTEGRATION_ALLOWLIST_ROWS.reduce((acc, row) => {
        acc[row.key] = true;
        return acc;
    }, {});
}
export function normalizeApiKeyIntegrationAllowlist(raw) {
    return {
        ...defaultApiKeyIntegrationAllowlist(),
        ...(raw || {}),
    };
}
export function getApiKeyIntegrationFormToggleFieldOptions(fieldPrefix = API_KEY_ALLOWLIST_FORMIK_PREFIX) {
    return API_KEY_INTEGRATION_ALLOWLIST_ROWS.map((row) => ({
        name: `${fieldPrefix}.${row.key}`,
        label: row.label,
    }));
}
//# sourceMappingURL=api_key_restriction.js.map